<form [formGroup]="medicalHistoryForm" (ngSubmit)="submitForm()">
  <div class="mb-8 w-full flex justify-end">
    <p-float-label>
      <p-datepicker [id]="id + 'data'" appendTo="body" formControlName="date" dateFormat="dd/mm/yy"
        [pTooltip]="formWatched['children']['date']() | formFieldFeedback" [maxDate]="today" tooltipEvent="hover"
        class="max-w-[150px]" required />
      <label [for]="id + 'data'">Data da Consulta</label>
    </p-float-label>
  </div>
  <div class="mb-8">
    <p-float-label>
      <textarea [id]="id + 'detalhes'" rows="5" pTextarea formControlName="detail"
        [pTooltip]="formWatched['children']['detail']() | formFieldFeedback" resize="none" tooltipEvent="focus"
        tooltipPosition="bottom" class="w-full" required></textarea>
      <label [for]="id + 'detalhes'">Detalhes</label>
    </p-float-label>
  </div>
  <div class="mb-8">
    <p-float-label>
      <textarea [id]="id + 'alergias'" rows="5" pTextarea formControlName="allergies" resize="none" tooltipEvent="focus"
        tooltipPosition="bottom" class="w-full"></textarea>
      <label [for]="id + 'alergias'">Alergias</label>
    </p-float-label>
  </div>
  <div class="mb-8">
    <p-float-label>
      <textarea [id]="id + 'problemas'" rows="5" pTextarea formControlName="healthProblems" resize="none"
        tooltipEvent="focus" tooltipPosition="bottom" class="w-full"></textarea>
      <label [for]="id + 'problemas'">Problemas de Saúde</label>
    </p-float-label>
  </div>
  <div class="mb-8">
    <p-float-label>
      <textarea [id]="id + 'medicacao'" rows="5" pTextarea formControlName="medication"
        [pTooltip]="formWatched['children']['medication']() | formFieldFeedback" resize="none" tooltipEvent="focus"
        tooltipPosition="bottom" class="w-full"></textarea>
      <label [for]="id + 'medicacao'">Medicação</label>
    </p-float-label>
  </div>
  <p-button styleClass="w-full mb-4 font-semibold" [loading]="isLoading()" [disabled]="isLoading() || !enabled()"
    type="submit" [label]="initialData() ? 'Atualizar' : 'Cadastrar'" />
</form>